<template>
    <div>
        <div class="top-nav">
            <router-link @click="go" to="" class="icon icon-arrow-left"></router-link>   
            <span v-text="$route.meta.title"></span>     
        </div>
        <router-view></router-view>        
    </div>
</template>
<style lang="less" scoped>
    @import "~assets/less/icon.less";
    .top-nav{
       padding:20px 50px;
       border-bottom:2px solid #beb0b0;
       overflow: hidden;
       position: relative;
       text-align: center;
       color:#8e62f4;
       font-size: 40px;
       a.icon{
        position:absolute;
        left:10px;
        top:15px;
        // transform: translateY(-50%)  rotate(-90deg);
        
       }
    }
</style>
<script>
export default {    
    methods:{
        go () {
            console.log(123);
            this.$router.go(-1)
        }
    }
}
</script>